<template>
  <card>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
      :setImport="true"
      :exportFields="exportFields"
    />
  </card>
</template>
<script>
export default {
  name: "customers",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      exportFields: {
        "Полное имя": "full_name",
        "Номер телефона": {
          field: "phone",
          callback: (value) => {
            return "UZ " + value;
          },
        },
        Активность: {
          field: "is_moderated",
          callback: (value) => {
            return value ? "Да" : "Нет";
          },
        },
        Роли: {
          field: "roles",
          callback: (value) => {
            let roles = "";
            for (let i = 0; i < value.length; i++) {
              roles +=
                value[i].title +
                (value.length == 0 || i == value.length - 1 ? "" : " / ");
            }
            return roles;
          },
        },
      },
      modalCreate: "customer",
      fields: [
        {
          col: "col-12 col-md-6",
          key: "phone",
          label: "Номер телефона",
          type: "mask",
          mask: "+998#########",
          placeholder: "+998",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_customer",
      itemLink: "business/customers",
      setLink: "business/customers",
      columns: [
        {
          key: "is_moderated",
          title: "Активен",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "last_name",
          title: "Фамилия",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "first_name",
          title: "Имя",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          key: "phone",
          title: "Номер телефона",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "roles",
          title: "Роли",
          object: "title",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          disableLink: true,
        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },

        {
          detail: true,
          remove: false,
        },
      ],
    };
  },
};
</script>
<style>
</style>
